import {connect} from 'react-redux';
import React, {Component} from 'react';
import {ListGroupItem} from 'reactstrap';
import {selectCategory} from 'manuals/actions/category';

@connect(
    state => ({
        selectedCategory: state.manuals.selectedCategory
    }),
    dispatch => {
        return {
            select: (category) => dispatch(selectCategory(category)),
        }
    }
)
export default class Category extends Component {
    render() {
        const {
            templateCategory,
            select,
            selectedManualCategory,
            index
        } = this.props;
        return (
            <ListGroupItem
                onClick={() => select(templateCategory)}
                className='btn btn-link text-left'
                active={selectedManualCategory && selectedManualCategory.id === templateCategory.id}
            >
                {index}. {templateCategory.name}
            </ListGroupItem>
        )
    }
}
